import './ProjectsSection.css'

import { useState } from "react"
import ButtonFilters from "./ButtonFilters"
import ProjectsGrid from "./ProjectsGrid"

// Import projects' data
import { data } from "./data.jsx"
data.forEach( (value, i) => {data[i].id = i} ); // framer-motion won't animate correctly without numeric ids


export default function ProjectsSection() {

    const [filteredProjects, setFilteredProjects] = useState(data);

    return (
  
      <>
        <section id="portfolio">

          <h2 className="text-3xl font-bold text-center dark:text-light">Skills & Projects</h2>
          <div className="w-12 h-1 bg-primary mx-auto mt-2"></div>
          <h5 className="text-xl text-center dark:text-light mt-2">My Recent Work</h5>

          
          <ButtonFilters projects={data} setFilteredProjects={setFilteredProjects} />
  
          <div className="image-container">
            <ProjectsGrid filteredProjects={filteredProjects} />
          </div>
  
        </section>
      </>
  
    )
}
